/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MessageSequenceStatus } from '../models/MessageSequenceStatus';
import type { RebillMessage } from '../models/RebillMessage';
import type { RebillMessageForm } from '../models/RebillMessageForm';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RebillMessagesRestControllerService {
    /**
     * @returns RebillMessage OK
     * @throws ApiError
     */
    public static edit({
        creatorId,
        messageId,
        requestBody,
    }: {
        creatorId: number,
        messageId: number,
        requestBody: RebillMessageForm,
    }): CancelablePromise<RebillMessage> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/settings/rebill-messages/{creatorId}/{messageId}',
            path: {
                'creatorId': creatorId,
                'messageId': messageId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static deleteRebillMessage({
        creatorId,
        messageId,
    }: {
        creatorId: number,
        messageId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/settings/rebill-messages/{creatorId}/{messageId}',
            path: {
                'creatorId': creatorId,
                'messageId': messageId,
            },
        });
    }
    /**
     * @returns RebillMessage OK
     * @throws ApiError
     */
    public static createRebillMessage({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: RebillMessageForm,
    }): CancelablePromise<RebillMessage> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/settings/rebill-messages/{creatorId}',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns RebillMessage OK
     * @throws ApiError
     */
    public static apiToggleMessageActivation({
        creatorId,
        messageId,
        requestBody,
    }: {
        creatorId: number,
        messageId: number,
        requestBody: MessageSequenceStatus,
    }): CancelablePromise<RebillMessage> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/settings/rebill-messages/{creatorId}/{messageId}/toggle-message',
            path: {
                'creatorId': creatorId,
                'messageId': messageId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static apiToggleRebillMessages({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: boolean,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/settings/rebill-messages/{creatorId}/toggle',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static apiSetSendAfterMinutes({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/settings/rebill-messages/{creatorId}/minutes',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static apiSetMinHoursSinceLastMessage({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/settings/rebill-messages/{creatorId}/hours-since-last-message',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
